import React, { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-kit-react/views/landingPageSections/listStyle.js";
import { isMobileOnly } from "react-device-detect";
import Button from "components/CustomButtons/Button.js";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
const useStyles = makeStyles(styles);

const ListSection = ({ doc, english, handleScroll }) => {
  const [expandList, setExpandList] = useState(false);
  const classes = useStyles();
  if (doc != null) {
    doc.sort((a, b) => a.title[0].text.localeCompare(b.title[0].text));
  }
  // run this function from an event handler or pass it to useEffect to execute scroll
  return (
    <div className={classes.list}>
      {expandList && (
        <Tooltip title={english ? "Collapse" : "Mininer"} placement="top">
          <IconButton onClick={() => setExpandList(false)}>
            <ExpandLessIcon fontSize="large" style={{ color: "white" }} />
          </IconButton>
        </Tooltip>
      )}
      {doc &&
        doc.map((item, index) => (
          <div className={classes.listRoot} key={index}>
            {expandList ? (
              <div>
                {english ? (
                  <>
                    <h3 className={classes.listHeadings}>
                      {item.title[0].text}
                    </h3>
                    <h4
                      className={classes.listHeadings}
                      style={{ color: "#F7776E" }}
                    >
                      {item.investment_size_usd[0].text}
                    </h4>
                    <p
                      className={
                        isMobileOnly
                          ? classes.listItemsMobile
                          : classes.listItems
                      }
                    >
                      {item.english_text[0].text}
                    </p>
                  </>
                ) : (
                  <>
                    <h3 className={classes.listHeadings}>
                      {item.title[0].text}
                    </h3>
                    <h4
                      className={classes.listHeadings}
                      style={{ color: "#F7776E" }}
                    >
                      {item.investment_size[0].text}
                    </h4>
                    <p
                      className={
                        isMobileOnly
                          ? classes.listItemsMobile
                          : classes.listItems
                      }
                    >
                      {item.text[0].text}
                    </p>
                  </>
                )}
              </div>
            ) : (
              index < 2 && (
                <div>
                  {english ? (
                    <>
                      <h3 className={classes.listHeadings}>
                        {item.title[0].text}
                      </h3>
                      <h4
                        className={classes.listHeadings}
                        style={{ color: "#F7776E" }}
                      >
                        {item.investment_size_usd[0].text}
                      </h4>
                      <p
                        className={
                          isMobileOnly
                            ? classes.listItemsMobile
                            : classes.listItems
                        }
                      >
                        {item.english_text[0].text}
                      </p>
                    </>
                  ) : (
                    <>
                      <h3 className={classes.listHeadings}>
                        {item.title[0].text}
                      </h3>
                      <h4
                        className={classes.listHeadings}
                        style={{ color: "#F7776E" }}
                      >
                        {item.investment_size[0].text}
                      </h4>
                      <p
                        className={
                          isMobileOnly
                            ? classes.listItemsMobile
                            : classes.listItems
                        }
                      >
                        {item.text[0].text}
                      </p>
                    </>
                  )}
                </div>
              )
            )}
          </div>
        ))}
      <Tooltip
        title={
          expandList
            ? english
              ? "Collapse"
              : "Mininer"
            : english
            ? "View more companies"
            : "Se flere selskaper"
        }
        placement="bottom"
      >
        <Button color="github" onClick={() => setExpandList(!expandList)}>
          {expandList ? (
            <>
              <ExpandLessIcon fontSize="large" style={{ color: "white" }} />
              {english ? "Minimize" : "Minimer"}
            </>
          ) : (
            <>
              <ExpandMoreIcon fontSize="large" style={{ color: "white" }} />
              {english ? "View more" : "Se flere"}
            </>
          )}
        </Button>
      </Tooltip>
      {expandList && (
        <div className={classes.stickyButton}>
          <Button round justIcon color="forest" onClick={handleScroll}>
            <ArrowUpwardIcon style={{ color: "white" }} />
          </Button>
        </div>
      )}
    </div>
  );
};

ListSection.propTypes = {
  doc: PropTypes.array,
  english: PropTypes.bool,
  handleScroll: PropTypes.func,
};

export default ListSection;
